<template>
  <div>
  <!-- <div class="container"> -->
    <div class="cards-1 row px-3 justify-content-center">
      <div class="col-lg-4 col-xxl-3 mb-2">
        <div class="card py-3 px-5 px-xs-4 pe-sm-2 ps-sm-4 px-md-5 px-xl-5">
          <div class="card-body ">
            <div class="justify-content-center">
              <div class="card-icon mx-auto blue">
                <span class="far fa-file-alt"></span>
              </div>
              <h5 class="card-title text-center mt-1 mt-lg-0 mx-2">
                Economic
              </h5>
            </div>
            <div class="row justify-content-center">
              <ul dir="ltr" class="list-unstyled li-space-lg col-7 col-sm-4 col-md-3 col-lg-9 col-xl-7">
                <li class="">
                  <div class="d-flex">
                    <i class="fas fa-check mx-2"></i>
                    <div class="flex-grow-1">picture gallery</div>
                  </div>
                </li>
                <li class="">
                  <div class="d-flex">
                    <i class="fas fa-check mx-2"></i>
                    <div class="flex-grow-1">contact info</div>
                  </div>
                </li>
                <li class="">
                  <div class="d-flex">
                    <i class="fas fa-times mx-2"></i>
                    <div class="flex-grow-1">admin panel</div>
                  </div>
                </li>
                <li class="">
                  <div class="d-flex">
                    <i class="fas fa-times mx-2"></i>
                    <div class="flex-grow-1">
                      payment gateway
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xxl-3 mb-2">
        <div class="card py-3 px-5 px-xs-4 pe-sm-2 ps-sm-4 px-md-5 px-xl-7">
          <div class="card-body">
            <div class="justify-content-center">
              <div class="card-icon mx-auto red">
                <span class="fas fa-gift"></span>
              </div>
              <h5 class="card-title text-center mt-1 mt-lg-0 mx-2">
              Special
              </h5>
            </div>
            <div class="row justify-content-center">
              <ul dir="ltr" class="list-unstyled li-space-lg col-7 col-sm-4 col-md-3 col-lg-9 col-xl-7">
              <li class="">
                 <div class="d-flex">
                  <i class="fas fa-check mx-2"></i>
                  <div class="flex-grow-1">online shop</div>
                  </div>
                </li>

                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check mx-2"></i>
                  <div class="flex-grow-1">payment gateway</div>
                  </div>
                </li>

                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check mx-2"></i>
                  <div class="flex-grow-1">admin panel</div>
                  </div>
                </li>

                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check mx-2"></i>
                  <div class="flex-grow-1">periodic report</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xxl-3 mb-2">
        <div class="card py-3 px-5 px-xs-4 pe-sm-2 ps-sm-4 px-md-5 px-xl-7">
          <div class="card-body">
            <div class="justify-content-center">
              <div class="card-icon mx-auto yellow">
                <span class="fas fa-solar-panel"></span>
              </div>
              <h5 class="card-title text-center mt-1 mt-lg-0 mx-2">
                Custom-made
              </h5>
            </div>
            <div class="row justify-content-center">
              <ul dir="ltr" class="list-unstyled li-space-lg col-7 col-sm-4 col-md-3 col-lg-9 col-xl-7">
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check mx-2"></i>
                  <div class="flex-grow-1">office website</div>
                  </div>
                  </li>
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check mx-2"></i>
                  <div class="flex-grow-1">employment form</div>
                  </div>
                  </li>
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check mx-2"></i>
                  <div class="flex-grow-1">admin panel</div>
                  </div>
                  </li>
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check mx-2"></i>
                  <div class="flex-grow-1">your idea</div>
                  </div>
                  </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "PlansEn",
};
</script>

<style>
</style>